import { CLAIM_TYPES } from '@/common/constants/validClaims';
import { getMaxClaimDate } from '@/common/functions/getMaxClaimDate';
import moment from 'moment';

export const checkOverdue = (claim) => {
	const maxClaimDate = getMaxClaimDate(claim);

	return (
		moment(maxClaimDate, 'DD.MM.YYYY').isBefore(moment()) &&
		claim.type === CLAIM_TYPES.REFUND
	);
};
